module.exports = __webpack_public_path__ + "img/GAME_GATU1.2311fc8d.jpg";